import { request } from '../utils/request';

export const getWalletRebatesByOwnerId = ({ ownerId } = {}) =>
  request({
    url: `/wallet-rebates/getByOwnerId`,
    method: 'GET',
    params: { ownerId },
    data: {},
  });

export const getWalletRebatesByListOwnerId = ({ ownerIds = [] } = {}) =>
  request({
    url: `/wallet-rebates/getByListOwnerId`,
    method: 'GET',
    params: { ownerIds },
    data: {},
  });

export const updateTotalReceived = ({ id, ownerId, totalReceived } = {}) =>
  request({
    url: `/wallet-rebates/${id}/updateTotalReceived`,
    method: 'PUT',
    params: { ownerId, totalReceived },
    data: {},
  });

export const deleteWallet = id =>
  request({
    url: `/wallet-rebates/${id}`,
    method: 'DELETE',
  });